//@ts-nocheck
export const isValidPassword = (value) => {
  return /[\W_]/.test(value);
};
